<style scoped>
    img.avator {
        width: 35px;
        height: 35px;
    }

    img.v {
        width: 15px;
        height: 15px;
        right: -1px;
        bottom: 5px;
    }
</style>

<template>
    <div>
        <img class="img-circle avator" :src="img" :style="{width:size + 'px', height:size + 'px'}">
        <img class="pa v" src="/assets/img/account/c@2x.png" v-if="user.isCompanyUser || user.isCompanyAdmin">
        <img class="pa v" src="/assets/img/account/v@2x.png" v-if="isVip">
    </div>
</template>

<script lang="babel">
    /**
     * 头像
     */
    import {user} from 'bootsets/runtime'
    import {Features} from 'core/constant'
    export default {
        components: {},
        props: {
            size: {
                type: Number,
                default: 35
            },
            img: {
                type: String,
                coerce(val) {
                    return val || '/assets/img/report/portrait_default.png'
                }
            }
        },
        data() {
            return {
                user
            }
        },
        computed: {
            isVip() {
                return Boolean(this.user.features & Features.VIP_ENABLED)
            }
        }
    }
</script>




// WEBPACK FOOTER //
// avator.vue?78f1f574